module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Settings-2-844a537fcc35b2036e993c51c9d7f52e.svg";